<template lang="html">
  <section class="popup">
    <div class="popup-wrapper">

      <div class="popup-header">
        Állapot
      </div>
      <div class="popup-container">
        {{defaultTypeMessage}}

        {{stateMessage}}
      </div>
      <div class="popup-footer">
        <button @click="close()">
          Bezárás
        </button>
      </div>
    </div>
  </section>

</template>

<script>


export default {
  data: function(){
    return {
      messages$: {
        failed: "Nem sikerült a módosítás!",
        success: "Sikeres módosítás!",
        success_add_to_offer: "Az ajánlatot továbbítottuk a megadott e-mail címre",
        success_add_to_wp_cart: "A megrendelés hozzáadva a kosárhoz"
      },
    }
  },
  props: [
    'response',
    'responseType',
    'popupState',
    //küldött üzenet
    'stateMessage',
    'checkoutPage'
  ],
  computed: {
    defaultTypeMessage() {
      let
        message = ''
      if(typeof this.messages$[this.responseType] != 'undefined') {
        message = this.messages$[this.responseType]
      }
      return message
    }
  },
  methods: {
    close() {
      this.$emit('update:popupState',false)
      if(this.responseType == 'success_add_to_wp_cart') {
        //redirect checkout page
        window.location.href = this.checkoutPage
      } else if (this.responseType == 'success_add_to_offer') {
        window.location.href = '/'
      }
    },
  }
}
</script>
<style lang="scss">
.popup{
  display: flex;
  position: fixed;
  align-content: center;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.65);
  width: 100%;
  min-height: 100vh;
  z-index: 99;
  &-wrapper{
    width: 300px;
    background: white;
    box-shadow: 5px 5px 25px rgba(0,0,0,.4);
    border-radius: 5px;
    overflow: hidden;
  }
  &-header{
    background: #888;
    color: white;
    padding: .5em .8em;
    font-size: 1.2em;
  }
  &-container{
    padding: .5em .8em;
    font-size: 1.15em;
  }
  &-footer{
    margin-top: 2em;
    padding: .5em .8em;
    text-align: right;
    button{
      background: #777;
      height: 40px;
      line-height: 40px;
      text-transform: capitalize;
    }
  }
}
</style>
